'use strict';

import { getLoginRequiredResolveObj } from '../shared/utils/angularUtils';
import { NAVIGATION_ICON } from '../shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../shared/constants/user-info/solutionType';

export const chatModule = angular
  .module('app.chat', [])
  .config(chatModuleConfig);

chatModuleConfig.$inject = ['$routeProvider'];

function chatModuleConfig($routeProvider) {
  $routeProvider.when('/chat', {
    template: `<ngz-chat-page></ngz-chat-page>`,
    resolve: getLoginRequiredResolveObj(),
    pageConfig: {
      solution: SOLUTION_TYPE.NUTRITION,
      breadcrumbs: [
        { label: 'Messages', icon: NAVIGATION_ICON.CHAT }
      ]
    }
  });
}